import React, { useState } from "react";
import { Container, Navbar, Dropdown, InputGroup, Form, Nav } from "react-bootstrap";
import Logo from '../../assets/images/logo-horizontal.svg'
import { Link } from "react-router-dom";
import IconPos from '../../assets/images/menu-icon/icon-pos.svg'
import IconInventory from '../../assets/images/menu-icon/icon-Inventory.svg'
import IconStaffing from '../../assets/images/menu-icon/icon-staffing.svg'
import IconCrm from '../../assets/images/menu-icon/icon-crm.svg'
import IconFinance from '../../assets/images/menu-icon/icon-finance.svg'
import IconAdmin from '../../assets/images/menu-icon/icon-admin.svg'
import { RiMenuUnfoldLine } from "react-icons/ri";
import MobileLogo from "../../assets/images/logo-verticle.svg"
import CommonSearch from "../Common/CommonSearch";
import { useMenu, MenuKeys } from "../../context/MenuContext";

const ModuleNav = () => {
    const { selectedMenuKey, setSelectedMenuKey } = useMenu();

    const handleMenuClick = (menuKey: MenuKeys) => {
        setSelectedMenuKey(menuKey);
    };

    return (
        <>
            <Nav className="module-nav">
                <Link 
                    to="/pos/dashboard" 
                    className={`nav-link ${selectedMenuKey === MenuKeys.POS ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.POS)}
                >
                    <img src={IconPos} className="menu-icon" alt="icon" /> POS
                </Link>
                <Link 
                    to="/inventory/dashboard" 
                    className={`nav-link ${selectedMenuKey === MenuKeys.INVENTORY ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.INVENTORY)}
                >
                    <img src={IconInventory} className="menu-icon" alt="icon" /> Inventory & Waste Management
                </Link>
                <Link 
                    to="/staffing/employee-directory" 
                    className={`nav-link ${selectedMenuKey === MenuKeys.STAFFING ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.STAFFING)}
                >
                    <img src={IconStaffing} className="menu-icon" alt="icon" /> Staffing
                </Link>
                <Link 
                    to="/crm/dashboard" 
                    className={`nav-link ${selectedMenuKey === MenuKeys.CRM ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.CRM)}
                >
                    <img src={IconCrm} className="menu-icon" alt="icon" /> CRM
                </Link>
                <Link 
                    to="/finance/dashboard" 
                    className={`nav-link ${selectedMenuKey === MenuKeys.FINANCE ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.FINANCE)}
                >
                    <img src={IconFinance} className="menu-icon" alt="icon" /> Finance
                </Link>
                <Link 
                    to="/restaurant-admin/dashboard" 
                    className={`nav-link ${selectedMenuKey === MenuKeys.RESTAURANT_ADMIN ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.RESTAURANT_ADMIN)}
                >
                    <img src={IconAdmin} className="menu-icon" alt="icon" /> Restaurant Admin
                </Link>
            </Nav>
        </>
    )
}

const Header = () => {
    const { selectedMenuKey } = useMenu();
    // Toggle body class for mobile menu
    const [menuOpen, setMenuOpen] = useState(false);
    const handleMenuToggle = () => {
        document.body.classList.toggle('show-mo-menu');
        setMenuOpen((prev: boolean) => !prev);
    };

    const getActiveModuleInfo = () => {
        switch (selectedMenuKey) {
            case MenuKeys.POS:
                return { icon: IconPos, text: 'POS' };
            case MenuKeys.INVENTORY:
                return { icon: IconInventory, text: 'Inventory & Waste Management' };
            case MenuKeys.STAFFING:
                return { icon: IconStaffing, text: 'Staffing' };
            case MenuKeys.CRM:
                return { icon: IconCrm, text: 'CRM' };
            case MenuKeys.FINANCE:
                return { icon: IconFinance, text: 'Finance' };
            case MenuKeys.RESTAURANT_ADMIN:
                return { icon: IconAdmin, text: 'Restaurant Admin' };
            default:
                return { icon: IconPos, text: 'POS' };
        }
    };

    const activeModule = getActiveModuleInfo();
    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar>
                        <a
                            href="javascript:void(0);"
                            className={`text-primary-2 d-lg-none mo-menu-toggle${menuOpen ? ' mo-menu-open' : ''}`}
                            onClick={handleMenuToggle}
                        >
                            <RiMenuUnfoldLine size="24" />
                        </a>
                        <Navbar.Brand className="">
                            <img src={Logo} width={193} height={32} alt='Logo' className=" align-text-top d-none d-lg-block" />
                            <img src={MobileLogo} width={80} alt='Logo' className=" align-text-top d-lg-none d-block" />
                        </Navbar.Brand>
                        <div className="d-block d-lg-none ms-auto">
                            <Dropdown className="module-dd"  align="end" autoClose='outside'>
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                     <img src={activeModule.icon} className="menu-icon" alt="icon" /> {activeModule.text}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <ModuleNav />
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="d-none d-lg-block">
                            <ModuleNav />
                        </div>
                        <div className="d-none d-lg-block align-items-center ms-auto gap-3 col-lg-3" >
                            <div className="w-100">
                                <CommonSearch />
                            </div>
                        </div>
                    </Navbar>
                </Container>
            </header>

        </>
    )
}
export default Header;